import React, { useEffect, useState } from "react";
import SideNav, { TopScreenLoader } from "./sideNav";
import { BsTextIndentRight } from "react-icons/bs";
import { ToastContainer } from "react-toastify";
import { useAppContext } from "../context/appContext";
import { MapScheduleGuardManagement } from "./sideNavComponents";
import {
  MdFormatIndentIncrease,
  MdOutlineFormatIndentDecrease,
  MdOutlineFormatIndentIncrease,
} from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import PopupModel from "./model/popupModel";

// const sideNav_WIDTH = 15

const Layout = ({ children }) => {
  const {
    showSideNav,
    setShowSideNav,
    removeNav,
    setRemoveNav,
    UserType,
    isAuthUser,
    isPopupOpen,
    setIsPopupOpen,
    popupMessage,
    isGlobalLoading,
    loadingText,
    isMobileScreen,
  } = useAppContext();
  // const [] = useState(false);

  // console.log(removeNav);

  const location = useLocation();
  
  // Check if we're on auth pages (login, register, etc.)
  const isAuthPage = location.pathname === '/' || 
                    location.pathname === '/login' || 
                    location.pathname === '/register' || 
                    location.pathname === '/resetpassword' ||
                    location.pathname === '/role' ||
                    location.pathname.includes('/verifyuser');
  const isPathNameForPasswordVerification =
    location.pathname.includes("/verifyuser");
  const PathName = location.pathname;

  console.log("UserType", UserType);

  return UserType?.role === "admin" && !isPathNameForPasswordVerification ? (
    <div className="h-screen flex bg-white overflow-hidden font-sans">
      <ToastContainer position="top-right" autoClose={4000} />
      <PopupModel />
      <TopScreenLoader
        isVisible={isGlobalLoading && !isAuthPage}
        text={loadingText}
        showText={false}
      />

      {/* {isAuthUser && ( */}
      <SideNav
        className={`h-full transition-all ease-in-out duration-500 hidden md:block bg-white border-r border-zinc-100 w-[20%] md:w-[16rem] translate-x-0`}
      />
      {/* )} */}
      <div
        className={`transition-all  relative flex flex-col items-center bg-zinc-50  w-full md:w-[calc(100%-16rem)] duration-500 h-full`}
      >
        {removeNav && (
          <div
            className={`absolute z-50  transition-width ease-in-out duration-500 w-full h-full md:hidden    ${
              removeNav ? "w-full block" : "w-0 hidden "
            } `}
          >
            <SideNav
              className={`absolute top-0 left-0 w-60 h-full transition-all ease-in-out duration-300 ${
                removeNav
                  ? "translate-x-0 opacity-100"
                  : "-translate-x-full opacity-0"
              }`}
              isMobile={true}
            />

            <div
              className={`bg-black/30 h-full w-full transition-opacity duration-300 ${
                removeNav ? "opacity-100" : "opacity-0"
              }`}
              onClick={() => setRemoveNav(false)}
            ></div>
          </div>
        )}

        <Header className="h-12 w-full block md:hidden" />
        <div className="w-full flex justify-center overflow-y-auto md:h-full h-[calc(100%-3rem)] ">
          <div className=" h-full flex justify-center  w-full xl:max-w-[1600px] 2xl:max-w-[2500px] relative ">
            {children}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="relative">
      <ToastContainer position="top-right" autoClose={4000} />
      <PopupModel />
      <TopScreenLoader
        isVisible={isGlobalLoading && !isAuthPage}
        text={loadingText}
        showText={false}
      />
      {children}
    </div>
  );
};

export default Layout;

export const PixelStyle = "md:px-5 pb-10 px-10 w-full  globalScroll";

export const Header = ({ className }) => {
  const { showSideNav, setShowSideNav, removeNav, setRemoveNav } =
    useAppContext();
  // console.log(showSideNav);

  const handleSidebarToggle = () => {
    // Only toggle in mobile mode (when removeNav is being used)
    // On desktop, sidebar should always stay open
    setRemoveNav(!removeNav);
  };

  return (
    <div className={`${className} flex items-center gap-2 justify-between `}>
      <button className="text-sm p-1 " onClick={handleSidebarToggle}>
        {removeNav ? (
          <MdOutlineFormatIndentDecrease />
        ) : (
          <MdOutlineFormatIndentIncrease />
        )}
      </button>
      <div className="flex items-center gap-2 ">
        {/* <img
          src='https://robohash.org/a5b6f884b905457c348f699eb265c5fa?set=set4&bgset=&size=400x400'
          className='bg-green-200 rounded-full p-1 h-8'
          alt=''
        /> */}
        {/* <h1 className='text-xl font-semibold'>John</h1> */}
      </div>
    </div>
  );
};
